import { MdxLayout } from '../../components/MdxLayout';

const Posts = () => {
  const posts = [
    {
      title: 'Pre-rendering Test4',
      date: '2024-02-05',
      slug: 'pre-rendering-test4',
    },
    {
      title: 'Pre-rendering Test3',
      date: '2024-02-04',
      slug: 'pre-rendering-test3',
    },
    {
      title: 'Pre-rendering Test2',
      date: '2024-02-03',
      slug: 'pre-rendering-test2',
    },
    {
      title: 'Pre-rendering Test1',
      date: '2024-02-02',
      slug: 'pre-rendering-test1',
    },
  ];
  return (
    <ul>
      {posts.map((post) => (
        <li style={{ marginBottom: '15px' }}>
          <a href={`/blog/${post.slug}`}>
            <span style={{ fontSize: '20px' }}>{post.date}</span>:{' '}
            <span style={{ fontSize: '18px', textDecoration: 'underline' }}>{post.title}</span>
          </a>
        </li>
      ))}
    </ul>
  );
};
export default function MDXPage({}) {
  return (
    <MdxLayout>
      <Posts />
    </MdxLayout>
  );
}
